import type { FaireProductEntity } from "../../entity_types/product";

export const p_98en0mlx: FaireProductEntity = {
  token: "p_98en0mlx",
  type: "product",
  name: "Mexican Citrus Juicer",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/6c35f56ada7b30b4e9aecfb02bd9acee0e15169c6ecc943c74c4292bf863551a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4fbd5fd46fbd7628c8f8dd6c13bea58c4809008de1cef6adb161d69d23f03e83.jpeg",
    "https://cdn.faire.com/fastly/45dbac77799ca65c2f0fa50224dbdbe0b30127079321fda341d79ed4ec81f7b1.jpeg",
    "https://cdn.faire.com/fastly/66fa31fee36f1fc8b71e172e12f06c8722c5b618efec92f559a6251148c68aed.jpeg",
    "https://cdn.faire.com/fastly/3d1115e3e77c55449f5904ee6c725567f7ec748c1216cfc791ade688f9fba82c.jpeg",
    "https://cdn.faire.com/fastly/6ebc4acd4e0fbb38338765375e7b44b486766a42b81088e37ca03e5efe11ce53.jpeg",
    "https://cdn.faire.com/fastly/5dd841bd4a07762afcbf9e7f4cdc45736fa1606718dfcda43216ee35881b1077.jpeg",
    "https://cdn.faire.com/fastly/c32e7d38f47e53b8020588627ef3e88fdb1934e4a1e0a4314c82dfd389d52637.jpeg",
  ],
  priceDollars: 49.5,
  description:
    'Transform holiday gatherings with the Verve Culture Artisan Citrus Juicer, a perfect gift for any occasion. Crafted from durable, recycled, cast aluminum, this authentic tool brings the charm of traditional markets to your kitchen. Delight in making delicious, healthy juices or crafting unique cocktails with friends and family. Size ideal for small-med citrus fruits.\n\nThe juicer comes beautifully packaged in a gift box, making it an ideal present for holiday gift exchanges, Christmas, weddings, housewarmings, Mother’s Day, Father’s Day, and other special celebrations. Included is a brochure with recipes, fun facts, and easy cleaning instructions to enhance the gift experience.\n\nThis Juicer is not just a tool, but a centerpiece for memories with loved ones. Perfect for gifting, this juicer combines functionality with a touch of heritage, making it a thoughtful addition to any wish list.\n\nHandle up/juicer open: 12" L x 5.5" W x 18.5" H\nHandle down/juicer closed: 14" L x 5.5" W x 13.5" H',
  tags: [],
  msrpDollars: 99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:19.877Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
